import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const GlamClub = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M26.625,44.032l-21.125,0c-0.979,0 -1.7,-0.974 -1.45,-1.975l5.215,-20.87c0.17,-0.69 0.77,-1.174 1.45,-1.174l0.72,0l0,-14.545c0,-0.83 0.67,-1.5 1.5,-1.5l6.255,0c0.829,0 1.5,0.67 1.5,1.5l0,14.54l0.72,0c0.68,0 1.275,0.484 1.45,1.174l0.815,3.256l0,-16.135c0,-0.831 0.669,-1.501 1.5,-1.501l7.764,0c0.831,0 1.501,0.67 1.501,1.501l0,15.435c5.329,0.314 9.56,4.724 9.56,10.134c0,5.61 -4.55,10.16 -10.165,10.16c-2.131,0 -4.1,-0.655 -5.736,-1.775c0.116,0.925 -0.559,1.775 -1.474,1.775Zm-2.851,-8.86l-15.939,0l-1.715,6.86l19.895,0l-0.635,-2.545c-0.845,-1.265 -1.4,-2.734 -1.606,-4.315Zm10.066,6.86c4.5,0 8.16,-3.665 8.16,-8.165c0,-4.499 -3.66,-8.159 -8.16,-8.159c-4.13,0 -7.545,3.085 -8.08,7.069l1.46,5.851c1.484,2.059 3.894,3.404 6.62,3.404Zm0,-13.949c3.195,0 5.785,2.59 5.785,5.784c0,3.195 -2.59,5.785 -5.785,5.785c-3.195,0 -5.786,-2.59 -5.786,-5.785c0,-3.194 2.591,-5.784 5.786,-5.784Zm0,10.575c2.64,0 4.784,-2.146 4.784,-4.786c0,-2.634 -2.144,-4.785 -4.784,-4.785c-2.636,0 -4.785,2.146 -4.785,4.785c0,2.635 2.144,4.786 4.785,4.786l0,0Zm-12.83,-16.645l-9.89,0l-2.915,11.665l15.475,0l0,-0.981l-2.67,-10.684Zm11.429,-5.505l-6.764,0l0,11.125c1.209,-1.81 3.074,-3.426 6.764,-3.85l0,-7.275Zm-13.749,-6.576l-5.255,0l0,9.935l5.255,0l0,-9.935Zm13.749,-1.129l-6.764,0l0,6.2l6.764,0l0,-6.2Zm-13.749,-2.835l-5.255,0l0,2.465l5.255,0l0,-2.465Z" fill={fill} />
    </svg>
  );
};

GlamClub.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

GlamClub.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
